import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import md5 from 'js-md5';
import dayjs from "dayjs";
import { mapActions } from "vuex";
export default {
  data: function data() {
    return {
      timeInterval: null,
      time: dayjs().format("HH:mm:ss"),
      // 表单 admin abcd1234
      formLogin: {
        email: "",
        password: ""
      },
      rules: {
        email: [{
          required: true,
          message: "请输入用户名",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/account", ["login"])), {}, {
    refreshTime: function refreshTime() {
      this.time = dayjs().format("HH:mm:ss");
    },
    submit: function submit() {
      var _this2 = this;

      var data = _objectSpread(_objectSpread({}, this.formLogin), {}, {
        username: this.formLogin.email
      });

      data.password = md5(data.password); // data.password = 'e19d5cd5af0378da05f63f891c7467af'

      this.$store.dispatch('d2admin/account/login', data).then(function () {
        _this2.$router.replace(_this2.$route.query.redirect || "/");
      });
    }
  })
};